export const fieldGroupOptions = [
    { label: "Driver's License", value: 'driverLicense' },
    { label: 'Vehicle Insurance', value: 'vehicleInsurance' },
    { label: 'Driving Record', value: 'drivingRecord' },
    { label: 'Vehicle Registration', value: 'vehicleRegistration' },
    { label: 'Police Report', value: 'policeReport' },
    { label: 'Visa', value: 'visa' },
    { label: 'Passport', value: 'passport' },
    { label: 'Work Cover', value: 'workCover' }
];

export const STANDALONE_FIELDS_GROUP = 'standaloneFields'; // standaloneFields/ independently defined, not attached to a logical group
